import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom';
import axios from 'axios';
import loadable from '@loadable/component';
import { useNavigate } from 'react-router-dom';
import EditContent from './components/pages/editContent/EditContent';
import Contest from './components/pages/category/Contest';
import HeadToHead from './components/pages/category/HeadToHead';
import ResearchArt from './components/pages/articles/ResearchArt';
import SportsNews from './components/pages/articles/SportsNews';
import ContestWinner from './components/pages/category/ContestWinner';
import EditContactUs from './components/pages/category/EditContactUs';
import Notification from './components/pages/notification/Notification';
import Dnd from './components/pages/category/Dnd';
import NewsDetails from './components/pages/articles/NewsDetails';
import AddNews from './components/pages/articles/AddNews';
import ArticleDetail from './components/pages/articles/ArticleDetail';
import AddArticles from './components/pages/articles/AddArticles';
import Podcast from './components/pages/articles/Podcast';
import PodcastDetail from './components/pages/articles/PodcastDetail';
import AddPodcast from './components/pages/articles/AddPodcast';
import TeamNames from './components/pages/category/TeamNames';
import GameResult from './components/pages/category/GameResult';
import Winners from './components/pages/category/Winners';
// import ContactUs from "./components/pages/contactUs/ContactUs";
// import ContactDetail from "./components/pages/contactUs/ContactDetail";
// import LayoutPage from './components/pages/shared/Layout';
import './index.css';
import EditNoti from './components/pages/notification/EditNoti';

const NotFound = loadable(() => import('./components/Notfound'));
const Login = loadable(() => import('./components/auth/Login'));
const ForgotPassword = loadable(
  () => import('./components/auth/ForgotPassword'),
);
const VerifyForgotPassword = loadable(
  () => import('./components/auth/VerifyForgotOtp'),
);
const ResetPassword = loadable(() => import('./components/auth/ResetPassword'));
const Dashboard = loadable(() => import('./components/pages/Dashboard'));
const Usermanager = loadable(() => import('./components/pages/User/list'));
const AllContests = loadable(
  () => import('./components/pages/dashboardLists/AllContests'),
);
const AllPredictions = loadable(
  () => import('./components/pages/dashboardLists/AllPredictions'),
);
const AllRankings = loadable(
  () => import('./components/pages/dashboardLists/AllRankings'),
);

// user management

//file management

const Filesection = loadable(
  () => import('./components/pages/filedatamanagement/Addfile'),
);

const ExcelFiles = loadable(
  () => import('./components/pages/filedatamanagement/ExcelFiles'),
);

// Game section

const Game = loadable(() => import('./components/pages/game/list'));
const NewGame = loadable(() => import('./components/pages/game/addgame'));

// Sport category

const Categorylist = loadable(() => import('./components/pages/category/list'));
const Addcategory = loadable(
  () => import('./components/pages/category/addCategory'),
);
const Editcategory = loadable(
  () => import('./components/pages/category/editCategory'),
);
const Prediction = loadable(
  () => import('./components/pages/category/Prediction'),
);
const Content = loadable(() => import('./components/pages/category/Content'));
const Ranking = loadable(() => import('./components/pages/category/Ranking'));
const TrackUser = loadable(() => import('./components/pages/TrackUser'));
const Contact = loadable(
  () => import('./components/pages/contactUs/ContactUs'),
);
const ContactDetail = loadable(
  () => import('./components/pages/contactUs/ContactDetail'),
);

const Banner = loadable(() => import('./components/pages/banner/Banner'));
const BannerDetail = loadable(
  () => import('./components/pages/banner/BannerDetail'),
);
const AddBanner = loadable(() => import('./components/pages/banner/AddBanner'));
const SiteSettings = loadable(
  () => import('./components/pages/settings/SiteSettings'),
);
const Badges = loadable(() => import('./components/pages/badges/Badges'));
const EloManagement = loadable(
  () => import('./components/pages/elo/EloManagement'),
);
const CommentsManagement = loadable(
  () => import('./components/pages/comments/CommentsManagement'),
);
const ChallengeManagement = loadable(
  () => import('./components/pages/challenges/ChallengeManagement'),
);

const List = loadable(() => import('./components/pages/lookingFor/List'));
const ListDetail = loadable(
  () => import('./components/pages/lookingFor/ListDetail'),
);

const TopHeadlines = loadable(
  () => import('./components/pages/topHeadlines/TopHeadlines'),
);
const HeadlineDetail = loadable(
  () => import('./components/pages/topHeadlines/HeadlineDetail'),
);
const AddHeadline = loadable(
  () => import('./components/pages/topHeadlines/AddHeadline'),
);
const NotificationList = loadable(
  () => import('./components/pages/notification/List'),
);
const NotiDetail = loadable(
  () => import('./components/pages/notification/NotiDetail'),
);
const Social = loadable(() => import('./components/pages/social/Social'));
const EditSocial = loadable(
  () => import('./components/pages/social/EditSocial'),
);

const EmailMarketing = loadable(
  () => import('./components/pages/emailMarketing/AddFile'),
);

// const
// sport Championship

// const championship section

const Championshiplist = loadable(
  () => import('./components/pages/championship/list'),
);

const ChangePassword = loadable(
  () => import('./components/auth/ChangePassword'),
);

let navigate = null;

axios.defaults.baseURL = 'https://algosports23.com/api/v1';
//  Request interceptor
axios.interceptors.request.use((request) => {
  let bearertoken = localStorage.getItem('angolosport_auth_back');
  // console.log("bbbbb-----",bearertoken)
  if (bearertoken !== null) {
    bearertoken = JSON.parse(bearertoken).token;
  }
  request.headers['Authorization'] = 'Bearer ' + bearertoken;
  // request.headers["accept"] = "*"
  return request;
});
//  response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem('angolosport_auth_back');
        navigate('/');
      }
    }
    return Promise.reject(error);
  },
);

const ProtectedRoute = () => {
  navigate = useNavigate();
  if (!localStorage.getItem('angolosport_auth_back')) {
    return <Navigate to="/" />;
  }
  return <Outlet />;
};

const PublicRoute = () => {
  if (localStorage.getItem('angolosport_auth_back')) {
    return <Navigate to="/dashboard" />;
  }
  return <Outlet />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename="/">
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-password/otp" element={<VerifyForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/contests" element={<AllContests />} />
        <Route path="/predictions" element={<AllPredictions />} />
        <Route path="/rankings" element={<AllRankings />} />
        <Route path="/change-password" element={<ChangePassword />} />

        {/* user path  */}
        <Route path="/user" element={<Usermanager />} />
        {/* End user path  */}

        {/* use file   */}
        <Route path="/file" element={<ExcelFiles />} />
        <Route path="/add-file" element={<Filesection />} />
        {/* End file  */}

        {/* Game path  */}
        <Route path="/game" element={<Game />} />
        <Route path="/game/addgame" element={<NewGame />} />
        {/* End Game Path  */}

        {/* category path  */}
        {/* <Route path="/category" element={<Categorylist />} /> */}
        <Route path="/category/addcategory" element={<Addcategory />} />
        <Route path="/category/editcategory/:id" element={<Editcategory />} />
        <Route path="/category/prediction/:id" element={<Prediction />} />
        <Route path="/category/ranking/:id" element={<Ranking />} />
        <Route path="/category/contest/:id" element={<Contest />} />
        <Route path="/category/headToHead/:id" element={<HeadToHead />} />
        <Route path="/contest-winner" element={<ContestWinner />} />
        <Route path="/sport-category" element={<Dnd />} />
        <Route path="/category/teamNames/:id" element={<TeamNames />} />
        <Route path="/category/gameResult/:id" element={<GameResult />} />
        <Route path="/category/winners/:id" element={<Winners />} />

        <Route path="/content" element={<Content />} />
        <Route path="/content/edit/:id" element={<EditContent />} />
        <Route
          path="/content/edit-contact-us/:id"
          element={<EditContactUs />}
        />
        <Route path="/track-user/:user/:category" element={<TrackUser />} />

        {/* End category path  */}

        {/* Notification path */}
        <Route
          path="/notification/send-notification"
          element={<Notification />}
        />
        <Route path="/notification" element={<NotificationList />} />
        <Route path="/notification/:id" element={<EditNoti />} />

        {/* End Notification path */}

        {/* Championship path  */}
        <Route path="/Championship" element={<Championshiplist />} />
        {/* End Championship path  */}

        {/* Articles and Video path */}
        <Route path="/research-articles" element={<ResearchArt />} />
        <Route path="/research-articles/:id" element={<ArticleDetail />} />
        <Route path="/research-articles/addArticle" element={<AddArticles />} />
        <Route path="/blogs" element={<SportsNews />} />
        <Route path="/blogs/:id" element={<NewsDetails />} />
        <Route path="/blogs/add-news" element={<AddNews />} />
        <Route path="/podcast" element={<Podcast />} />
        <Route path="/podcast/:id" element={<PodcastDetail />} />
        <Route path="/podcast/add-podcast" element={<AddPodcast />} />

        {/* End of Articles and  Video path */}

        {/* ContactUs path */}
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/contact-detail/:id" element={<ContactDetail />} />
        {/* End of Contact Us */}

        {/* Banner path */}
        <Route path="/banner" element={<Banner />} />
        <Route path="/banner/:id" element={<BannerDetail />} />
        <Route path="/banner/add-banner" element={<AddBanner />} />
        <Route path="/site-settings" element={<SiteSettings />} />
        <Route path="/badges" element={<Badges />} />
        <Route path="/elo-management" element={<EloManagement />} />
        <Route path="/comments" element={<CommentsManagement />} />
        <Route path="/challenges" element={<ChallengeManagement />} />
        {/* End Banner Path */}

        {/* Looking-For path */}
        <Route path="/looking-for" element={<List />} />
        <Route path="/looking-for/:id" element={<ListDetail />} />
        {/* Looking-for path end */}

        {/* Headlines path */}
        {/* <Route path="/headline" element={<TopHeadlines />} />
        <Route path="/headline/:id" element={<HeadlineDetail />} />
        <Route path="/headline/add-headline" element={<AddHeadline />} /> */}
        {/* End Headlines Path */}

        {/* social Path */}
        <Route path="/social" element={<Social />} />
        <Route path="/edit-social/:id" element={<EditSocial />} />
        {/* email-marketing */}
        <Route path="/email-marketing" element={<EmailMarketing />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
